'use strict';
import React from 'react';
import reactDom from 'react-dom';
import { Link } from 'react-router-dom';
import userAction from '../../actions/userAction';
import userStore from '../../stores/userStore';

class ResetForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            warningMsg: userStore.getState().warningMsg,
            processing: userStore.getState().processing,
            isfgPwdReset: userStore.getState().isfgPwdReset,
            newPassword: "",
            confirmPassword: "",
        }
    }

    componentDidMount() {
        userStore.listen(this.onChange);
        userAction.warningMsg('');
    }

    componentWillUnmount() {
        userStore.unlisten(this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isfgPwdReset && this.state.isfgPwdReset != prevState.isfgPwdReset) {
            console.log('repeat');
            userAction.warningMsg.defer("Password Successfully Reset. You will be redirected to login page in 3 seconds ");
            window.setTimeout(() => {
                this.props.history.push('/');
            }, 3000);

        }
    }
    onChange(state) {
        this.setState({
            warningMsg: state.warningMsg,
            processing: state.processing,
            isfgPwdReset: state.isfgPwdReset,
        });
    }

    handleChange(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let value = e.target.value;

        if (index == 0) {
            this.setState({ newPassword: value });
        } else {
            this.setState({ confirmPassword: value });
        }
    }
    handleSubmit(e) {
        let npwd = reactDom.findDOMNode(this.refs.npwd);
        let cpwd = reactDom.findDOMNode(this.refs.cpwd);
        try {
            npwd.reportValidity();
            cpwd.reportValidity();
        } catch (e) {

        }

        if (!npwd.checkValidity()) return;
        if (!cpwd.checkValidity()) return;

        if (this.state.processing) return;

        if (!this.validatePassword(this.state.newPassword)) return;

        if (this.state.newPassword != this.state.confirmPassword) {
            return userAction.warningMsg("Password not tally");
        }

        userAction.processing(true);
        userAction.resetFgPassword(this.props.match.params.token, this.state.newPassword);

    }
    handleKeyPress(e){
        if(e.key == 'Enter'){
            e.preventDefault();
            this.handleSubmit();
        }
    }
    validatePassword(password) {
        if (password.length < 8) {
            userAction.warningMsg("Password length must be minimum 8 characters");
            return false;
        } else if (password.match(/[A-Z]/g) == null) {
            userAction.warningMsg("Password must be at least one Capital letter");
            return false;
        }
        return true;
    }
    render() {
        return (

            <div className="ul-w">
                <h2> A4 International </h2>
                <div className="ul-tt">Reset Password</div>
                <div className="ul-warning">{this.state.warningMsg}</div>
                <form >
                    <div className="form-group">
                        <div className="ul-in">
                            <input type="password" ref="npwd" className="form-control"
                                placeholder="New Password" data-index="0" onChange={this.handleChange} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="ul-in">
                            <input type="password" ref="cpwd" className="form-control"
                                placeholder="Confirm New Password" data-index="1" onChange={this.handleChange} 
                                onKeyPress={this.handleKeyPress} required />
                        </div>
                    </div>
                    <button type="button" className="btn btn-default" onClick={this.handleSubmit}>Change</button>
                </form>
            </div>
        );
    }
}
export default ResetForgotPassword;


// WEBPACK FOOTER //
// ./app/components/userComponents/resetForgotPassword.js